import React, { useEffect, useState } from "react";
import { AccountsVM } from "../../../Models/ViewModels";
import {
  AddAccount,
  DeleteAccount,
  EditAccount,
} from "../../../Services/AccountsDB";
import { GetUserLoginID } from "../../../Services/UserSessionManager";
import { ToastContainer, toast } from "react-toastify";
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import ModalTitle from "rsuite/esm/Modal/ModalTitle";
import ModalBody from "rsuite/esm/Modal/ModalBody";
import { Button, Input, Modal } from "rsuite";
type attributes = {
  type: string;
  title: string;
  data: AccountsVM;
  onAction: any;
  cachedData: Array<AccountsVM>;
};

export const AddEditDeleteAccount = (props: attributes) => {
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [newAccount, setNewAccount] = useState(new AccountsVM());
  const [open, setOpen] = React.useState(true);
  const [displayButton, setDisplayButton] = useState(false);

  useEffect(() => {
    setNewAccount(props.data);
    if (props.type == "edit") {
      setDisplayButton(true);
    }
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  const handelAccountModification = () => {
    if (!newAccount.IsNonVC) {
      alert("Account Type is mandatory");
      return;
    }
    if (props.type == "edit") {
      EditAccount(newAccount, loginid)
        .then((res) => {
          props.onAction();
          handleClose();
          toast.info("Updated successfully !");
        })
        .catch((err) => {
          toast.error("Failed to Update !");
        });
    } else if (props.type == "add") {
      AddAccount(newAccount, loginid)
        .then((res) => {
          if (res.data == 1) {
            props.onAction();
            handleClose();
            toast.success("Added successfully");
          } else toast.error("Account trying to add is already Active!");
        })
        .catch((err) => {
          toast.error("Failed to Add !");
        });
    } else if (props.type == "delete") {
      DeleteAccount(newAccount.AccountID)
        .then((res) => {
          props.onAction();
          handleClose();
          toast.error("Deleted successfully");
        })
        .catch((err) => {
          toast.error("Failed to Delete !");
        });
    }
  };

  const handleInput = (value: any, event: any) => {
    console.log(event);
    let value1 =
      event.target.type === "number" ? +event.target.value : event.target.value;
    setNewAccount({ ...newAccount, [event.target.name]: value1 });
  };
  if (props.type == "delete") {
    return (
      <div className="modal-container">
        <ModalHeader>
          <ModalTitle>
            <h4>{props.title}</h4>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete {newAccount.AccountName}
        </ModalBody>
        <Modal.Footer>
          <Button onClick={handelAccountModification} appearance="primary">
            Delete
          </Button>
        </Modal.Footer>
      </div>
    );
  } else {
    return (
      <div className="modal-container">
        <Modal.Header>
          <Modal.Title>
            <h3>{props.title}</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalTitle>Account Name</ModalTitle>
          <Input
            type="text"
            name="AccountName"
            value={newAccount.AccountName}
            onChange={(value, event) => handleInput(value, event)}
          />
          <ModalTitle>Account Code</ModalTitle>
          <Input
            type="text"
            name="AccountCode"
            value={newAccount.AccountCode}
            onChange={(value, event) => handleInput(value, event)}
          />
          <ModalTitle>VC Account Ref ID</ModalTitle>
          <Input
            type="number"
            name="VCAccountRefID"
            value={newAccount.VCAccountRefID}
            onChange={(value, event) => handleInput(value, event)}
          />

          <ModalTitle>
            VCAccount / Non VCAccount <span style={{ color: "red" }}>*</span>
          </ModalTitle>
          <Input
            type="text"
            name="IsNonVC"
            value={newAccount.IsNonVC}
            onChange={(value, event) => handleInput(value, event)}
            placeholder="Enter 0 for VC & 1 for NonVC Account"
            required
          />
        </Modal.Body>
        {displayButton ? (
          <Modal.Footer>
            {" "}
            <Button onClick={handelAccountModification} appearance="primary">
              Update
            </Button>
          </Modal.Footer>
        ) : (
          <Modal.Footer>
            <Button onClick={handelAccountModification} appearance="primary">
              Add
            </Button>
          </Modal.Footer>
        )}
      </div>
    );
  }
};
